export default {
  // Brand & meta
  "brand.name": "USFansLink",
  "brand.tagline": "Centro de recursos independiente de USFans Spreadsheet",
  "meta.home.title": "USFans Spreadsheet: guías, reseñas, envíos y novedades",
  "meta.home.description": "Explora la USFans Spreadsheet: guías de productos, consejos de QC, información de envío, recursos de almacén, reseñas y las últimas novedades de USFans.",
  "meta.article.title": "Guía de USFans Spreadsheet: qué es y cómo usarla",
  "meta.article.description": "Una guía completa e independiente de la USFans Spreadsheet: cómo funciona, cómo investigar productos, consejos de categorías, controles de QC, envío y seguridad básica.",

  // Navigation
  "nav.home": "Inicio",
  "nav.guide": "Guía de USFans Spreadsheet",
  "nav.buyingGuide": "Guía de compra",
  "nav.categories": "Categorías",
  "nav.faq": "Preguntas frecuentes",
  "nav.explore": "Explorar la hoja",

  // Hero
  "hero.badge": "Centro de recursos independiente",
  "hero.title": "USFans Spreadsheet: encuentra productos, guías y recursos más rápido",
  "hero.subtitle": "Tu recurso independiente sobre la USFans Spreadsheet: investigación de productos, guías de QC, información de envío, consejos de almacén y reseñas de USFans.",
  "hero.supporting": "¿Buscas la USFans Spreadsheet? Empieza aquí. Explora recursos de productos organizados, aprende a investigar productos, entiende la información de QC, compara opciones y toma mejores decisiones antes de comprar.",
  "hero.cta.primary": "USFans Spreadsheet",
  "hero.cta.secondary": "Comprar ahora",
  "hero.cta.guide": "Leer la guía de USFans",
  "hero.trust": "Recursos actualizados · Guías independientes · Información centrada en la seguridad",

  // Category dropdown
  "categories.dropdown.label": "Explorar categorías",
  "categories.dropdown.hint": "Selecciona una categoría para abrirla en el sitio principal",

  // Category names
  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Pantalones cortos",
  "cat.headwear": "Gorras y sombreros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior",
  "cat.jersey": "Camisetas deportivas",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  // Categories section
  "categories.title": "Categorías de productos populares",
  "categories.subtitle": "Salta directamente a una categoría en el sitio principal. Cada botón abre la página de producto correspondiente.",

  // About section
  "about.title": "¿Qué es la USFans Spreadsheet?",
  "about.body": "La USFans Spreadsheet es un recurso de descubrimiento e investigación de productos. Ayuda a los usuarios a organizar la información de productos, explorar categorías e investigar productos antes de tomar una decisión de compra. En lugar de saltar entre páginas dispersas, puedes revisar artículos, comparar opciones y consultar detalles en un solo lugar.",
  "about.body2": "Nuestro trabajo en USFansLink es hacer ese proceso más fácil. Publicamos guías independientes y fáciles de entender que explican cómo funciona la hoja, cómo leer la información de productos y qué verificar antes de gastar tu dinero.",

  // Why section
  "why.title": "¿Por qué usar nuestros recursos de USFans?",
  "why.subtitle": "Todo lo que hay aquí está escrito para ayudarte a investigar con más confianza, sin empujarte hacia un único vendedor.",
  "why.items": [
    "Información organizada",
    "Guías para principiantes",
    "Tutoriales de investigación de productos",
    "Explicaciones de QC",
    "Información de envío",
    "Guías de almacén",
    "Recursos de reseñas",
    "Conocimiento de cupones",
    "Información de seguridad",
    "Actualizaciones periódicas"
  ],

  // Guide section
  "guide.title": "Cómo usar la USFans Spreadsheet",
  "guide.body": "Unos pocos hábitos sencillos hacen que la investigación de productos sea mucho más rápida. Aquí tienes un flujo de trabajo directo que puedes seguir, tanto si es tu primera compra como si investigas con regularidad.",
  "guide.steps": [
    "Elige una categoría que coincida con lo que buscas.",
    "Usa la búsqueda y los filtros para acotar la lista de productos.",
    "Revisa la información de producto que se muestra para cada artículo.",
    "Consulta las fotos o detalles de QC si están disponibles.",
    "Compara opciones y verifica la información actual antes de comprar."
  ],

  // Article entry
  "articleEntry.title": "Empieza con nuestra guía completa",
  "articleEntry.body": "¿Nuevo en la USFans Spreadsheet? Lee nuestra guía completa y original sobre cómo funciona, consejos de categorías, controles de QC, envío y seguridad, escrita para quienes buscan información clara y honesta.",
  "articleEntry.button": "Leer la guía completa",
  "articleEntry.meta": "Actualizado con regularidad · Independiente · Sin afiliación",

  // FAQ
  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas a las preguntas más habituales sobre la USFans Spreadsheet.",
  "faq.items": [
    {
      "q": "¿Qué es la USFans Spreadsheet?",
      "a": "Es un recurso de descubrimiento e investigación de productos que organiza la información de productos, categorías y enlaces para que los compradores puedan investigar los artículos antes de comprar."
    },
    {
      "q": "¿Cómo uso la USFans Spreadsheet?",
      "a": "Empieza eligiendo una categoría, luego usa la búsqueda y los filtros para acotar los resultados, revisa los detalles del producto y la información de QC, y compara opciones antes de comprar."
    },
    {
      "q": "¿Es seguro usar USFans?",
      "a": "La hoja en sí es una herramienta de investigación. Verifica siempre de forma independiente la información del producto, el vendedor y el pago, y ten cuidado con sitios falsos y enlaces sospechosos."
    },
    {
      "q": "¿Cuánto cuesta el envío de USFans?",
      "a": "Los costes de envío varían según el peso, las dimensiones, el destino y el método. Los precios reales pueden cambiar, así que consulta siempre la información actual antes de pedir."
    },
    {
      "q": "¿USFans tiene códigos de descuento?",
      "a": "Las promociones cambian a menudo. Nunca inventamos códigos de cupón, así que verifica siempre cualquier oferta actual en el sitio oficial antes de usarla."
    }
  ],

  // Final CTA
  "cta.title": "¿Listo para explorar la USFans Spreadsheet?",
  "cta.body": "Explora nuestras guías, comparaciones, reseñas y recursos para facilitar tu investigación de USFans.",
  "cta.button": "Explorar USFans Spreadsheet",

  // Articles section
  "articles.title": "Últimas guías de USFans",
  "articles.subtitle": "Guías independientes y originales sobre la USFans Spreadsheet, reseñas, envío, almacén, QC, vendedores y seguridad.",
  "articles.read": "Leer",

  // Footer
  "footer.about": "USFansLink es un centro de recursos independiente para la USFans Spreadsheet. Publicamos guías, reseñas e información de seguridad para ayudar a los compradores a investigar con confianza.",
  "footer.resources": "Recursos",
  "footer.categories": "Categorías",
  "footer.languages": "Idiomas",
  "footer.disclaimer": "Este sitio web proporciona recursos informativos independientes. No garantizamos la autenticidad, seguridad, legalidad, calidad, disponibilidad ni rendimiento de ningún producto, vendedor, sitio web o servicio de terceros. Verifica siempre la información actual de forma independiente antes de realizar una compra.",
  "footer.rights": "Todos los derechos reservados.",

  // Article page
  "article.backHome": "Volver al inicio",
  "article.tocTitle": "Tabla de contenidos",
  "article.updated": "Última actualización",
  "article.published": "Publicado",
  "article.readTime": "min de lectura",
  "article.h1": "Guía de USFans Spreadsheet: qué es y cómo usarla",
  "article.intro": "La USFans Spreadsheet es un recurso de descubrimiento e investigación de productos utilizado por muchos compradores para consultar información organizada de productos, explorar categorías e investigar artículos antes de comprar. Esta guía independiente explica qué es la hoja, cómo funciona, cómo usarla y qué comprobar antes de comprar.",
  "article.intro2": "No estamos afiliados a ningún vendedor ni tienda. Nuestro objetivo es simple: ayudarte a tomar mejores decisiones con información clara y honesta.",
  "article.toc": [
    "¿Qué es la USFans Spreadsheet?",
    "Cómo funciona la USFans Spreadsheet",
    "Categorías de productos explicadas",
    "Cómo usar la USFans Spreadsheet",
    "Consejos de investigación de productos y QC",
    "Conceptos básicos de envío y almacén",
    "Consejos de seguridad antes de comprar",
    "Preguntas frecuentes"
  ],
  "article.s1Title": "¿Qué es la USFans Spreadsheet?",
  "article.s1Text": "La USFans Spreadsheet es un recurso estructurado que reúne la información de productos en un solo lugar. En lugar de visitar muchas páginas separadas, los compradores pueden revisar productos, categorías y enlaces desde una única vista organizada. Es utilizada habitualmente por personas que investigan zapatos, ropa y accesorios.",
  "article.s1Text2": "Es importante entender que la hoja es una herramienta de investigación y descubrimiento, no una tienda en sí. Señala productos y vendedores, pero la compra final y cualquier transacción ocurren en los sitios web a los que enlaza.",
  "article.s2Title": "Cómo funciona la USFans Spreadsheet",
  "article.s2Text": "La hoja normalmente organiza los productos en filas, y cada fila muestra detalles como el nombre del producto, la categoría, la información de precio y un enlace al anuncio. Los filtros y la búsqueda te ayudan a acotar una lista larga hasta los artículos que te importan.",
  "article.s2Text2": "Algunas versiones también incluyen notas o fotos de control de calidad (QC), que te dan una vista más cercana del producto antes de comprometerte. Trátalas como referencias útiles y no como garantías: la calidad puede variar entre artículos.",
  "article.s3Title": "Categorías de productos explicadas",
  "article.s3Text": "Los productos suelen agruparse en categorías claras para que encuentres lo que necesitas más rápido. La siguiente tabla enumera las categorías principales y qué buscar en cada una.",
  "article.s3Table.area": "Categoría",
  "article.s3Table.what": "Qué buscar",
  "article.s3Table.notes": "Notas",
  "article.s3Rows": [
    { "area": "Zapatos", "what": "Modelo, talla, color y estado", "notes": "Revisa la talla y las fotos de QC" },
    { "area": "Sudaderas / Suéteres", "what": "Ajuste, material y color", "notes": "Consulta las tablas de tallas si están disponibles" },
    { "area": "Camisetas", "what": "Talla, estampado y material", "notes": "Verifica las medidas" },
    { "area": "Chaquetas", "what": "Estilo, talla y temporada", "notes": "Confirma los detalles antes de pedir" },
    { "area": "Bolsos y accesorios", "what": "Tipo, dimensiones y color", "notes": "Revisa las descripciones de los artículos" }
  ],
  "article.s4Title": "Cómo usar la USFans Spreadsheet",
  "article.s4Text": "No necesitas herramientas especiales para usar la hoja de forma eficaz. Un flujo de trabajo sencillo y cuidadoso es suficiente.",
  "article.s4Steps": [
    "Elige una categoría que coincida con lo que buscas.",
    "Usa la búsqueda y los filtros para acotar la lista de productos.",
    "Abre un producto y lee su información completa.",
    "Consulta las fotos o notas de QC cuando estén disponibles.",
    "Compara dos o tres opciones antes de decidir.",
    "Verifica el precio actual, la disponibilidad y la información del vendedor."
  ],
  "article.s5Title": "Consejos de investigación de productos y QC",
  "article.s5Text": "Una buena investigación de producto se reduce a comprobar los detalles en lugar de confiar en una sola foto. Mira varias imágenes, lee la descripción con atención y compara el mismo producto entre fuentes cuando sea posible.",
  "article.s5Text2": "Las fotos de QC te muestran una vista más cercana del artículo real, incluidas las costuras, las etiquetas y cualquier marca visible. Úsalas para detectar problemas evidentes a tiempo, pero recuerda que una foto no sustituye a leer el anuncio completo.",
  "article.s6Title": "Conceptos básicos de envío y almacén",
  "article.s6Text": "El coste de envío depende de varios factores, como el peso, las dimensiones, el destino y el método de envío que elijas. La etapa de almacén es donde los productos pueden almacenarse, revisarse y prepararse antes de enviártelos.",
  "article.s6Text2": "Los precios y plazos de envío reales pueden cambiar. Consulta siempre las tarifas y estimaciones de entrega actuales antes de pedir, y ten en cuenta el seguimiento y las consideraciones de aduanas en los pedidos internacionales.",
  "article.s7Title": "Consejos de seguridad antes de comprar",
  "article.s7Text": "Mantente atento en cada paso. Verifica que estás en el sitio web correcto, comprueba dos veces la información del vendedor y del producto, y evita enlaces sospechosos o mensajes no solicitados que pidan datos personales.",
  "article.s7Text2": "Usa métodos de pago seguros, guarda los registros de tus pedidos y lee la información de reembolso o devolución antes de pagar. Si algo parece extraño, detente y verifica de forma independiente.",
  "article.faqTitle": "Preguntas frecuentes",
  "article.faq": [
    {
      "q": "¿Es gratis usar la USFans Spreadsheet?",
      "a": "La hoja es un recurso para consultar información de productos. Los detalles de acceso pueden variar, así que consulta la información actual en el sitio oficial."
    },
    {
      "q": "¿Puedo confiar en todos los productos de la hoja?",
      "a": "No. La hoja organiza la información, pero debes verificar de forma independiente los productos, vendedores y pagos antes de comprar."
    },
    {
      "q": "¿Cómo reviso las fotos de QC?",
      "a": "Cuando haya fotos de QC disponibles, revísalas en busca de costuras, etiquetas y marcas visibles, y compáralas con la descripción del producto."
    },
    {
      "q": "¿Qué debo hacer antes de pedir?",
      "a": "Confirma el precio actual, la disponibilidad, el coste de envío y los datos del vendedor, y lee la política de reembolso o devolución antes de pagar."
    }
  ],
  "article.relatedTitle": "Sigue leyendo",
  "article.relatedBody": "¿Quieres más? Vuelve a la página de inicio para explorar categorías de productos, descubrir nuestros recursos y encontrar más guías independientes.",
  "article.ctaTitle": "¿Listo para explorar la USFans Spreadsheet?",
  "article.ctaBody": "Ahora que entiendes cómo funciona, abre la USFans Spreadsheet y empieza a investigar productos con confianza.",
  "article.ctaButton": "Explorar USFans Spreadsheet",
  "article.author": "Equipo editorial de USFansLink",
  "article.categoryLabel": "Guía",
  "article.notFoundTitle": "Página no encontrada",
  "article.notFound": "No pudimos encontrar ese artículo.",
  "notFound.title": "Página no encontrada",
  "notFound.body": "La página que buscas no existe o se ha movido."
};